import getEnv from "@utils/getEnv";

export const TOKEN_HERE_MAPS_COOKIE_NAME = "token_here_maps";
export const MAX_TRIES = 5;

export const HERE_MAPS_ACCESS_KEYS = {
  lt: getEnv("HERE_API_OAUTH_TOKEN_ACCESS_KEY_LT"),
  lv: getEnv("HERE_API_OAUTH_TOKEN_ACCESS_KEY_LV"),
  ee: getEnv("HERE_API_OAUTH_TOKEN_ACCESS_KEY_EE"),
};

export const HERE_MAPS_SECRET_KEYS = {
  lt: getEnv("HERE_API_OAUTH_TOKEN_SECRET_KEY_LT"),
  lv: getEnv("HERE_API_OAUTH_TOKEN_SECRET_KEY_LV"),
  ee: getEnv("HERE_API_OAUTH_TOKEN_SECRET_KEY_EE"),
};
